export default {
    cost: {
        orgNameRequired: 'Please enter the organization name',
        status: 'Status',
        search: 'Search',
        accountList: 'Account List',
        orgName: 'Organization Name',
        billing: 'Billing Method',
        unlimited: "Unlimited annual package",
        Per: "Per view billing",
        Arrears: "Arrears",
        InService: "In service",
        DueSoon: "Due soon",
        recharge: 'Reminder recharge',
        sendSuccess: 'Successfully sent recharge reminder',
        manage: 'Manage',
        all: 'All'
    },
    account: {
        addData: "Add data",
        hasSelect: "Selected",
        classify: "Classification",
        dic: "Dictionary",
        english: "English",
        searchCondition: "Search Criteria",
        accountRequired: "Please enter your login name",
        orgNameRequired: "Please enter the organization name",
        startDate: "Start date",
        endDate: "End Date",
        accountList: "Account List",
        addAccount: "Add account",
        accountName: "Login Name",
        orgName: "Organization Name",
        createTime: "Opening time",
        nodeStatus: "Node Status",
        freeze: "Freeze",
        cancelFreeze: "Unfreeze",
        recover: "Restore",
        manage: "Management",
        to: "To",
        orgNameRequiredSelect: "Please select the organization name",
        uscCode: "Organizational Code",
        userName: "Administrator Name",
        telPhone: "Administrator's phone number",
        callAddress: "Application callback address",
        callbackUrl: "Front end machine call address",
        location: "Belonging place",
        autoComplete: "Automatically generated",
        userNameRequired: "Please enter the administrator's name",
        telPhoneRequired: "Please enter the administrator's phone number",
        callAddressRequired: "Please enter the application callback address",
        callbackUrlRequired: "Please enter the front-end machine call address",
        locationRequired: "Please select the place of origin",
        keyFile: "Importing blockchain on chain keys",
        upload: "Click to upload",
        keyFileTip: "Only txt files can be uploaded and should not exceed 500kb.",
        relationsList: "Type of affiliated Organization",
        legalPersonNameRequired: "Please enter the legal representative's name",
        fatherOrgIdRequired: "Please select the parent company",
        orgTradeTypeRequired: "Please select the industry to which the enterprise belongs",
        orgLevelRequired: "Please select account type",
        maxLength2To20: "Between 2 and 20 characters in length",
        maxLength2To50: "Between 2 and 50 characters in length",
        retryOrgCode: "Please organize the organization code again",
        orgCodeValid: "The organization code is a combination of numbers and letters, and the length is not more than 18 digits.",
        accountEdit: "Account Edit",
        fileTypeValid: "The file type can only be a txt file",
        fileMaxSize: "The upload file size cannot exceed 50MB! ",
        resetPassword: "Reset Password",
        importAccountInfo: "Export account information",
        syncToFrondEnd: "Synchronize to front end machine",
        adminTel: "Administrator Phone",
        importApp: "Import App",
        addDataModel: "Add Data Model",
        relativeDataModel: "Related Data Model",
        dataModelCode: "Digital Analog Number",
        dataModelName: "Digital Model Name",
        desc: "Overview",
        exportDeployFile: "Export deployment file",
        fileRequired: "Please upload the file",
        fileSelect: "Select file",
        successToSync: "Successfully synchronized to the front-end machine",
        pleaseSelectFile: "Please select the file that needs to be uploaded first",
        passwordResetTip: "The current operation will reset the password, please confirm if you want to continue",
        friendlyTip: "Friendly Reminder",
        passwordResetSuccess: "Password reset successful, new password is:",
        passwordResetError: "Password reset failed",
        basicInfo: "Basic Information",
        dataModelNameRequired: "Please enter a data model name",
        dataModelDesc: "Overview of Mathematical Modeling",
        descRquired: "Please enter an overview",
        appName: "App",
        appNameRequired: "Please select the app you belong to",
        dataCatalogue: "Data Catalog",
        data: "Data",
        dataModelNameRequired1: "Please enter the DataModel name",
        dataModelDescRequired: "Please enter a mathematical and analog overview",
        appNameValid: "The application can only be composed of letters, numbers, underscores, and Chinese characters.",
        dataModelDataAndCatalogueRequired: "Please add data directory and data",
        saveSuccess: "Save successful",
        keywordRequiredBeforeSearch: "Please enter keywords before searching",
        appContentRequired: "App content not filled in completely",
        dataModelNoEmpty: "Data directory/data cannot be empty",
        retrievalItemRequired: "Please add at least one retrieval item to facilitate data search.",
        addDataModelCatalogue: "Add Data Catalog",
        isSetRetrievalItem: "Set as retrieval item",
        type: "Type",
        file: "File",
        string: "String",
        isSetRetrievalItem1: "Set as retrieval item",
        searchCatalogueBykeyword: "Search for entries based on keywords",
        keyword: "Keyword",
        keywordRequired: "Please enter the keyword",
        settingToRetrieval: "Set as retrieval item",
        selectBusiness: "Check 'Configure Business Behavior',",
        name: "Name",
        category: "Category",
        companyName: "Company Name",
        applicationName: "Application Name",
        retrievalItem: 'Retrieval item',
        personal: "Individual",
        company: "Enterprise",
        digitalAnalogIntroduction: "Introduction to Digital Analog",
        editIntroduction: "Editing Introduction",
        saveIntroduction: "Save Introduction",
        haveES: 'Deploy ES or not'
    },
    certificate: {
        searchCondition: "Search Criteria",
        accountRequired: "Please enter your login name",
        orgNameRequired: "Please enter the organization name",
        certificateList: "Certificate List",
        account: "Login name",
        orgName: "Organization Name",
        certificateName: "Certificate Name",
        limitTime: "Validity period",
        certificateUpdateSuccess: "Certificate updated successfully"
    },
    companyType: {
        fuzzyTypeNameRequired: "Please enter a type name",
        companyTypeList: "Enterprise Type List",
        addCompanyType: "Add enterprise type",
        typeName: "TypeName",
        desc: "Overview",
        relativeCompany: "Related Enterprises",
        deleteCompanyTip: "Are you sure you want to delete this enterprise type? ",
        remark: "Type description",
        orgRelations: "Related Enterprises",
        orgRelationsRequired: "Please select an affiliated enterprise",
        typeNameValid: "Type names can only contain Chinese characters, letters, and numbers, and do not support special symbols! ",
        remarkRequired: "Please enter a type description",
        relativeCompanySuccess: "Successfully affiliated with a company",
        addCompanySuccess: "Successfully added enterprise type"
    },
    dataCataLog: {
        orgIdRequired: "Please select the affiliation organization",
        applyIdRequired: "Please select a data model",
        pleaseInput: "Please input",
        dataCata: "Data Catalog",
        orgName: "Organization Name",
        applyName: "Digital Analog Name",
    },
    dataExchange: {
        askforOrgIdRequired: "Please select the data requester",
        giveOrgIdRequired: "Please select a data provider",
        selectDate: "Select date",
        changeLog: "Exchange Record",
        applyName: "Scene",
        askforOrgName: "Data requester",
        giveOrgName: "Data provider",
        createdTime: "Application Time",
        look: "View",
        detailPageTitle: "On chain information throughout the entire process of data exchange",
        orgName: "Organization Name",
        activeName: "Behavior",
        operateTime: "Operation time",
        address: "Certificate storage address",
        time: "Certificate storage time",
        dataReceive: "Data Receiver",
        content: "Content",
        fileName: "File Name",
        identityInputNum: 'Certificate number'
    },
    dataModelMall: {
        applyNameRequired: "Please enter the DataModel name",
        orgId: "Belonging Organization",
        dataModelList: "Digital Analog List",
        applyName: "Digital Analog Name",
        desc: "Overview",
        orgName: "Belonging Organization",
        dataSource: "Data Source",
        frontEnd: "Front end machine",
        version: "Version",
        download: "downloadable",
        onlyPreview: "Preview only",
        dataDetail: "Data Details",
        companyName: "Company Name",
        appName: "App Name",
        dataCata: "Data Catalog",
        retrievalItem: "Retrieval item",
        data: "Data",
        basicInfo: "Basic Information"
    },
    digifax: {
        add: 'Add',
        DataDictionary: "Data Catalog Dictionary",
        DataDictionary2: "Data Dictionary",
        dataModelRequired: "Please enter the DataModel name",
        orgIdName: "Please select the company you belong to",
        appList: "App List",
        dataModelName: "Digital Model Name",
        desc: "Overview",
        orgName: "Belonging Organization",
        exportFile: "Export deployment file",
        syncApplyInfo: "Synchronize to front-end machine",
        syncApplyInfoSuccess: "Sync to front-end machine successful",
        dataQueryError: "Data query failed, please try again! ",
        configDataDic: "Configure Data Dictionary",
        classify: "Classification",
        pleaseSelect: "Please select",
        addClassify: "Add Category",
        subcategory: "Data category",
        dataList: "Data List",
        variableName: "Variable Name",
        cnName: "Chinese name",
        addData: "Add new data",
        classifyName: "Classification Name",
        dataCata: "Data Catalog",
        data: "Data",
        personal: "Individual",
        unnecessary: "Not mandatory",
        necessary: "must",
        classifyRequired: "Please enter a classification name",
        classifyValid: "Classification names can only contain Chinese characters, letters, and numbers, and do not support special symbols! ",
        getDataError: "Failed to retrieve data",
        contentNoEmpty: "The input content cannot be empty",
        variableValid: "Variable names only allow combinations of letters and underscores, and cannot start with an underline.",
        nameDuplication: "There are duplicates, please edit again",
        deleteDataTip: "Do you want to delete this data? ",
        variableNameValid: "Only combinations of letters and underscores are allowed, and the beginning cannot be an underline",
        dataSaveSuccess: "Data saved successfully",
        dataRequireError: "Data request failed",
        digitalPublish: "Digital and Analog Publishing",
        digitalIntroduction: "Introduction to Mathematical Modeling",
        cancel: "Cancel",
        ok: "OK",
        required: "Please fill in the introduction of mathematical modeling"

    },
    exRvidence: {
        orgIdRequired: "Please select the affiliation organization",
        applyNameRequired: "Please enter the DataModel name",
        bussinessNumRequired: "Please enter the business number",
        legalInfo: "Certificate Information",
        orgName: "Organization Name",
        applyName: "Digital Analog Name",
        businessNum: "Business Number",
        look: "View",
        legalDetail: "Deposit Details",
        desc: "Overview",
        legalSource: "Certificate Traceability",
        content: "Content",
        fileName: "File Name",
        identityInputNum: "Certificate number",
        identityInputTime: "Certificate storage time"
    },
    givEvidence: {
        orgIdRequired: "Please select the affiliated company",
        outputFlagRequired: "Please select status",
        applyNameRequired: "Please enter the DataModel name",
        bussinessNumRequired: "Please enter the business number",
        legalInfo: "Certificate Information",
        orgName: "Enterprise/Department Name",
        applyName: "App Name",
        createdTime: "Application Time",
        status: "Status",
        applying: "Applying",
        pass: "Certificate issued",
        applyRefuse: "Certificate issuance failed",
        errorContent: "Reason for certificate issuance failure",
        all: "All",
        bussinessNum: "Business Number"
    },
    dictionaries: {
        dict: 'Dictionary',
        dictPlaceholder: "please enter the dictionary name",
        english: 'English',
        englishPlaceholder: 'please enter the english name',
        type: 'Type',
        typePlcaeholder: 'please select the type',
        dictRequired: "please enter the dictionary name",
        englishRequired: "please enter the english name",
        typeRequired: "please enter the type name",
        file: 'File',
        string: 'String',
        editSuccess: "Edit success",
        addSuccess: 'Add success',
        newCategory: 'Add a new category',
        catgoryName: 'category name: ',
        catgoryPlaceholder: 'please enter the category name'
    },
    upgradeManage: {
        AppManagement: "App Management",
        PackageManagement: "Package Management",
        rePush: 'rePush',
        pushing: 'Pushing',
        versionNumberError: 'The format of the version number input is incorrect',
        inService: "In Service",
        notDetected: "Not Detected",
        offline: "Offline",
        detectionFail: "Detection Failed",
        searchWay: "Search Criteria",
        seriaNumPlaceholder: "Please enter the app number",
        applist: "App List",
        addApp: "Add App",
        seriaNum: "App Number",
        appName: "App Name",
        status: "Status",
        createdTime: "Create Time",
        update: 'Update',
        delete: 'Delete',
        online: 'Online',
        Offline: "Offline",
        view: "View",
        appUpdate: "Update App",
        appAdd: "Add App",
        onlineSuccess: 'Online Success',
        offlineSuccess: 'Offline Success',
        deleteConfirm: "This operation will permanently delete the app. Do you want to continue?",
        deleteSuccess: "Delete Success",
        appDetail: 'App Detail',
        pkgPlaceholder: "please enter package name",
        pkgList: 'Package List',
        viewRecord: 'View Recored',
        pkgId: 'Package ID',
        pkgName: 'Package Name',
        script: 'Start Script',
        pkgDirectory: "Package Directory",
        createDate: "Add Date",
        push: 'Push',
        createdVersion: "Create Version",
        viewVersion: 'View Version',
        versionNull: "Version is empty, unable to push!",
        pushPkg: "Push Package",
        updatePkg: "Update Package",
        addPkg: "Add Package",
        pushRecored: "Push Recored",
        updateRecored: "Update Recored",

        versionNumber: 'Version Number',
        PushingVersion: 'Push Version',
        versionInfo: 'Version Information',
        noversionInfo: "There is currently no version information available!",
        deleteVersion: "This operation will permanently delete the version.Do you want to continue?"
    }
}



// WEBPACK FOOTER //
// ./src/views/admin/admin.en.js